export const STYLE_LINK = {
    color: "#FF9900",
    cursor: "pointer"
};
export const STYLE_DISABLE_LINK = {
    pointerEvents: "none",
    cursor: "default",
    textDecoration: "none",
    color: "black"
}